import type { EditorPreset, TiptapExtension } from '.';
import { CommentsExtensions } from './comments';
import { GuideIntroExtensions } from './guide_intro';
import { AnswersExtensions } from './answers';
import { WikiExtensions } from './wiki';

export const getExtensionsForPreset = (preset: EditorPreset): Array<TiptapExtension> => {
   switch (preset) {
      case 'comments':
         return CommentsExtensions;
      case 'guide_intro':
         return GuideIntroExtensions;
      case 'answers':
         return AnswersExtensions;
      case 'wiki':
         return WikiExtensions;
      default:
         throw new Error(`Invalid preset: ${preset}`);
   }
};
